import { RedefinePasswordContainer } from "./RedefinePasswordContainer";

export function RedefinePasswordPage() {
  return (
    <RedefinePasswordContainer />
  );
}